require('../../modules/es6.function.bind');
module.exports = require('../../modules/_core').Function.bind;



// WEBPACK FOOTER //
// ./node_modules/core-js/fn/function/bind.js